import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { EstimateService } from 'projects/estimate/src/app/estimate.service';
import { CommonModule } from '@angular/common';
import { MatGridListModule } from '@angular/material/grid-list';

@Component({
  standalone: true,
  selector: 'app-estimate-timeframe',
  templateUrl: './estimate-timeframe.component.html',
  styleUrls: ['./estimate-timeframe.component.scss'],
  imports: [
    CommonModule,
    MatGridListModule
  ]
})

export class EstimateTimeframeComponent {
  public timeFrameEstimate$: Observable<Array<string>> = this.progress.timeFrameEstimate.asObservable();
  public timeSensitiveDetails$: Observable<Array<string>> = this.progress.timeSensitiveDetails.asObservable();
  public selectedProjectType$: Observable<string> = this.progress.selectedProjectType.asObservable();
  public selectedTimeFrame$: Observable<string> = this.progress.selectedTimeFrame.asObservable();

  constructor(private progress: EstimateService) {
    const store = this.progress.store.getValue();
    const autoPilot = this.progress.autoPilot.getValue();
    if (autoPilot && !store.stepTwo.display) {
      this.progress.enablePage(false);

      let timeFrameSub;

      timeFrameSub = this.progress.timeFrameEstimate.subscribe(
        (timeFrames: Array<string>) => {
          const selectedTimeFrame = timeFrames.find(s => s.includes('*'));
          if (selectedTimeFrame) {
            this.selectTimeFrame(selectedTimeFrame);
          } else if (timeFrames[0]) {
            this.selectTimeFrame(timeFrames[0]);
          }
          if (timeFrameSub) {
            timeFrameSub.unsubscribe();
          }
        }
      );
    }
  }

  addTitle(timeFrame: string) {
    return timeFrame.replace(': ', ': ~');
  }

  selectTimeFrame(selectedTimeFrame: any, reset: boolean = false): void {
    if (reset) this.progress.resetAfterTimeFrame();
    this.selectedTimeFrame$ = this.progress.selectedTimeFrame.asObservable();
    this.progress.prompts[2].setDisplayed([selectedTimeFrame, this.progress.summary]);
    this.progress.selectedTimeFrame.next(selectedTimeFrame);
  }
}
